module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', [_vm._v("Usuários por Projeto")]), _vm._v(" "), (!_vm.loading.tela && _vm._.isEmpty(_vm.usuarioEditando) && _vm.listaUsuarios.length > 0) ? _c('span', [_c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
    }],
    attrs: {
      "color": "success",
      "title": '<h5>Grava todas as alterações realizadas nos usuários do projeto <span class=\'realce\'>' + _vm.projetoSelecionado.ds_codigo_projeto_erp + ' - ' + _vm.projetoSelecionado.ds_nome + '</span></h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.permiteConcluir()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Usuários por projeto',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm._.isEmpty(_vm.usuarioEditando)) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal",
    attrs: {
      "id": "listaProjetos"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "listagemProjetos",
    attrs: {
      "options": _vm.listaProjetos,
      "multiple": false,
      "placeholder": "Selecione um projeto",
      "track-by": "id",
      "label": "ds_nome",
      "custom-label": function (option) {
        return ("" + (option.ds_codigo_projeto_erp + option.ds_nome + option.ds_situacao_erp))
      },
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome) + " (" + _vm._s(props.option.ds_situacao_erp) + ")\n                ")]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome) + " (" + _vm._s(props.option.ds_situacao_erp) + ")\n                ")]
      }
    }], null, false, 2541572116),
    model: {
      value: (_vm.projetoSelecionado),
      callback: function($$v) {
        _vm.projetoSelecionado = $$v
      },
      expression: "projetoSelecionado"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum projeto localizado!")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [(_vm.restricaoParaInicializar.length > 0) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.restricaoParaInicializar), function(restricao) {
    return _c('p', [_vm._v(_vm._s(restricao))])
  })], 2) : _vm._e()])]), _vm._v(" "), (!_vm._.isEmpty(_vm.listaUsuarios)) ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "alteracao_usuarios_entidade"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
    }],
    attrs: {
      "color": "primary",
      "type": "button",
      "title": '<h5>Clicar para iniciar cadastro de novo usuário que será vinculado ao projeto <span class=\'realce\'>' + _vm.projetoSelecionado.ds_codigo_projeto_erp + ' - ' + _vm.projetoSelecionado.ds_nome + '</span></h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novoUsuario()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo usuário\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": _vm.ajustaPesquisa,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(_vm.pesquisa.length > 0) ? _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.tabelaUsuarios.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pesquisa = '';
        _vm.tabelaUsuarios.filter = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-muted text-left"
  }, [_vm._v(_vm._s(_vm.pesquisa.length > 0 ? _vm.tabelaUsuarios.totalRows + ' localizado(s)' : ' '))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large', placement:'left'}"
    }],
    staticClass: "col-md-2 text-muted text-right",
    staticStyle: {
      "cursor": "default"
    },
    attrs: {
      "title": '<h5>Há três níveis de acesso aos projetos: <div class=\'legendas_acessos\'>' +
        '<p class=\'tag_sem_acesso\'>Podem entrar no SGP, se estiver ativo,<br> mas não terá acesso a este projeto</p>' +
        '<p class=\'tag_visualizacao_projeto\'>Terá acesso para ver o projeto e<br> acompanhar suas ações sem intervir</p>' +
        '<p class=\'tag_inicia_solicitacao\'>Acesso completo. Permite pedir <br>liberação de recursos, alteração de projeto etc</p>' +
        '</div></h5>'
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation"
  }), _vm._v("nformações\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    key: 'tabelaUsuarios_' + _vm.tabelaUsuarios.numeroAtualizacao,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "hover": "",
      "bordered": _vm.tabelaUsuarios.bordered,
      "items": _vm.listaUsuarios,
      "fields": _vm.tabelaUsuarios.fields,
      "current-page": _vm.tabelaUsuarios.currentPage,
      "per-page": _vm.tabelaUsuarios.perPage,
      "sort-by": _vm.tabelaUsuarios.sortBy,
      "sort-desc": _vm.tabelaUsuarios.sortDesc,
      "filter": _vm.tabelaUsuarios.filter,
      "filter-function": _vm.filtroPorItem,
      "empty-filtered-text": 'Não encontrei nada relacionado a ´' + _vm.pesquisa + '´ na pesquisa',
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tabelaUsuarios, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tabelaUsuarios, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tabelaUsuarios, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tabelaUsuarios, "sortDesc", $event)
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "ds_nome_usuario",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
          }],
          staticClass: "truncar",
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "title": '<h5>' + row.value + '</h5>'
          }
        }, [_vm._v(_vm._s(row.value))]), _vm._v(" "), (row.item.id === 0) ? _c('div', {
          staticClass: "text-green"
        }, [_vm._v("\n                      usuário novo\n                      "), _c('i', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          staticClass: "fa fa-close botao_excluir_usuario_novo",
          attrs: {
            "title": '<h5>Exclue esse usuário novo, que ainda não foi consta nesse projeto</h5>'
          },
          on: {
            "click": function($event) {
              return _vm.excluirUsuarioNovo(row.item.tempId)
            }
          }
        })]) : _vm._e()]
      }
    }, {
      key: "ds_email",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              delay: [500, 0]
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [500, 0]}"
          }],
          staticClass: "truncar",
          staticStyle: {
            "max-width": "200px"
          },
          attrs: {
            "title": '<h5>' + row.value + '</h5>'
          }
        }, [_vm._v(_vm._s(row.value))])]
      }
    }, {
      key: "ds_telefone",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("telefone")(row.value)))]
      }
    }, {
      key: "ds_cpf",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("cpf")(row.value)))]
      }
    }, {
      key: "acessos",
      fn: function(row) {
        return [_c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('acesso_' + row.item.tempId)
          }
        }, [_c('multiselect', {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          attrs: {
            "options": _vm.listaAcessos,
            "multiple": true,
            "placeholder": "",
            "track-by": "codigo",
            "label": "descricao",
            "preselect-first": false,
            "close-on-select": true,
            "max": 1,
            "disabled": row.item.ds_cpf === null,
            "selectLabel": "",
            "deselectLabel": "",
            "selectedLabel": "",
            "name": 'acesso_' + row.item.tempId
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(props) {
              return [_vm._v(_vm._s(props.option.descricao))]
            }
          }, {
            key: "singleLabel",
            fn: function(props) {
              return [_c('strong', [_vm._v(_vm._s(props.option.descricao))])]
            }
          }, {
            key: "maxElements",
            fn: function(props) {
              return [_vm._v("Se quiser trocar, exclua antes")]
            }
          }, {
            key: "tag",
            fn: function(props) {
              return [_c('span', {
                class: 'tag_acessos tag_' + _vm._.toLower(props.option.codigo)
              }, [_c('span', [_vm._v(_vm._s(props.option.descricao))]), _vm._v(" "), _c('span', {
                staticClass: "multiselect__tag-icon",
                on: {
                  "click": function($event) {
                    return props.remove(props.option)
                  }
                }
              })])]
            }
          }], null, true),
          model: {
            value: (row.item.acessos),
            callback: function($$v) {
              _vm.$set(row.item, "acessos", $$v)
            },
            expression: "row.item.acessos"
          }
        }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
          slot: "noResult"
        }, [_vm._v("Nenhuma acesso localizada!")])], 2), _vm._v(" "), (_vm.errors.first('acesso_' + row.item.tempId)) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" Deve selecionar um acesso")]) : _vm._e()], 1)]
      }
    }, {
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'fade',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'fade', distance:'1', size:'large'}"
          }],
          class: ('' + row.value) === '0' ? 'fa fa-circle text-red' : 'fa fa-circle text-green',
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "aria-hidden": "true",
            "title": '<h5>Situação do usuário: <div class=\'legendas_acessos text-left\'>' +
              '<p><i class=\'fa fa-circle text-red\'></i> <span class=' + (('' + row.value) === '0' ? 'realce' : '') + '>Inativo</span>: Não pode entrar no SGP</p>' +
              '<p><i class=\'fa fa-circle text-green\'></i> <span class=' + (('' + row.value) === '1' ? 'realce' : '') + '>Ativo</span>: Pode entrar no SGP</p>' +
              '<p>Clique para alterar para <b>' + (('' + row.value) === '0' ? 'ATIVO' : 'INATIVO') + '</b>,<br/> depois conclua as alterações</p></div></h5>'
          },
          on: {
            "click": function($event) {
              row.item.bt_ativo = ('' + row.value) === '0' ? 1 : 0
            }
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(row.item.ds_cpf !== null) ? _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editaUsuario(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]) : _vm._e()]
      }
    }], null, false, 3439086163)
  }), _vm._v(" "), (!_vm._.isEmpty(_vm.listaUsuarios) && _vm.listaUsuarios.length > _vm.tabelaUsuarios.perPage && _vm.tabelaUsuarios.totalRows > _vm.tabelaUsuarios.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.listaUsuarios.length,
      "per-page": _vm.tabelaUsuarios.perPage
    },
    model: {
      value: (_vm.tabelaUsuarios.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tabelaUsuarios, "currentPage", $$v)
      },
      expression: "tabelaUsuarios.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.usuarioEditando)) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm._.isNull(_vm.usuarioEditando.id) ? 'Criando usuário para' : (_vm.usuarioEditando.id === 0 ? 'Alterando usuário novo de ' : 'Editando usuário de'))), _c('b', [_vm._v(" " + _vm._s(_vm.projetoSelecionado.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.projetoSelecionado.ds_nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioEditando.ds_nome_usuario),
      expression: "usuarioEditando.ds_nome_usuario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:100'),
      expression: "'required|min:1|max:100'"
    }],
    ref: "ds_nome_usuario",
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "id": "nome",
      "type": "text",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.usuarioEditando.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioEditando, "ds_nome_usuario", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome do Usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf",
      "data-vv-as": "CPF",
      "id": "cpf",
      "type": "text",
      "disabled": _vm.ehVisualizacao,
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.usuarioEditando.ds_cpf),
      callback: function($$v) {
        _vm.$set(_vm.usuarioEditando, "ds_cpf", $$v)
      },
      expression: "usuarioEditando.ds_cpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('login')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "login"
    }
  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioEditando.ds_login),
      expression: "usuarioEditando.ds_login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:14'),
      expression: "'required|min:5|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login",
      "id": "login",
      "type": "text",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.usuarioEditando.ds_login)
    },
    on: {
      "blur": function($event) {
        return _vm.verificaLoginJaCadastrado()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioEditando, "ds_login", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('login')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('login')))]) : _vm._e()]), _vm._v(" "), (_vm.loading.verifica.login) ? _c('span', {
    staticClass: "text-blue"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" verificando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Telefone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "id": "telefone",
      "type": "text",
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.usuarioEditando.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.usuarioEditando, "ds_telefone", $$v)
      },
      expression: "usuarioEditando.ds_telefone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioEditando.ds_email),
      expression: "usuarioEditando.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "id": "email",
      "data-vv-as": "E-Mail",
      "type": "text",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.usuarioEditando.ds_email)
    },
    on: {
      "blur": function($event) {
        return _vm.verificaLoginJaCadastrado()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuarioEditando, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), (_vm.loading.verifica.email) ? _c('span', {
    staticClass: "text-blue float-right"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" verificando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('status')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Situação:")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioEditando.bt_ativo),
      expression: "usuarioEditando.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.usuarioEditando.bt_ativo, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.usuarioEditando, "bt_ativo", 1)
      }
    }
  }), _vm._v(" Ativo "), _c('i', {
    staticClass: "fa fa-circle text-green"
  }), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "15%"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioEditando.bt_ativo),
      expression: "usuarioEditando.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.usuarioEditando.bt_ativo, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.usuarioEditando, "bt_ativo", 0)
      }
    }
  }), _vm._v(" Inativo "), _c('i', {
    staticClass: "fa fa-circle text-red"
  }), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Status do Usuário é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('acesso_' + _vm.usuarioEditando.tempId)
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Acesso:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaAcessos,
      "multiple": true,
      "placeholder": "",
      "track-by": "codigo",
      "label": "descricao",
      "preselect-first": false,
      "close-on-select": true,
      "max": 1,
      "disabled": _vm.usuarioEditando.ds_cpf === null,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": 'acesso_' + _vm.usuarioEditando.tempId
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_vm._v(_vm._s(props.option.descricao))]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.descricao))])]
      }
    }, {
      key: "maxElements",
      fn: function(props) {
        return [_vm._v("Se quiser trocar, exclua antes")]
      }
    }, {
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          class: 'tag_acessos tag_' + _vm._.toLower(props.option.codigo)
        }, [_c('span', [_vm._v(_vm._s(props.option.descricao))]), _vm._v(" "), _c('span', {
          staticClass: "multiselect__tag-icon",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        })])]
      }
    }], null, false, 3180611249),
    model: {
      value: (_vm.usuarioEditando.acessos),
      callback: function($$v) {
        _vm.$set(_vm.usuarioEditando, "acessos", $$v)
      },
      expression: "usuarioEditando.acessos"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhuma acesso localizada!")])], 2), _vm._v(" "), (_vm.errors.first('acesso_' + _vm.usuarioEditando.tempId)) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar um acesso")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2 text-red"
  }, [_vm._v("\n                      Após concluir, este usuário novo será vinculado a este projeto e outro(s) " + _vm._s(_vm.listaProjetosEntidade.length - 1) + " projeto(s) desta entidade."), _c('br'), _c('br'), _vm._v("Para o(s) outro(s) projeto(s), este usuário estará "), _c('b', [_vm._v("Sem Acesso")]), _vm._v(" até que entre no projeto específico e conceda o acesso\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(_vm.errors.items.length === 0 && _vm._.keys(_vm.usuarioEditando).length >= 7 && !_vm.loading.verifica.login && !_vm.loading.verifica.email) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm._.isNull(_vm.usuarioEditando.id) ? _vm.adicionaUsuario() : _vm.alteraUsuario()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        _vm.usuarioEditando = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-200948e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/usuario/ProjetosUsuario.vue
// module id = 1793
// module chunks = 2